import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';
import getPersonContact, { updatePersonContact, confirmPersonContact } from './GetPersonContact';

const INITIAL_STATE = { ...BASIC_INITIAL_STATE };

const PersonContactData = { INITIAL_STATE, getPersonContact, updatePersonContact, confirmPersonContact };
export default PersonContactData;